import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignUp from "../container/Login/SignUp/SignUp";
import ForgotPassword from "../container/Login/ForgotPassword/ForgotPassword";
import OTPVerify from "../container/Login/OTPVerify/OTPVerify";
import CreatePassword from "../container/Login/CreatePassword/CreatePassword";
import VerifyMobileNumber from "../container/Login/VerifyMobileNumber/VerifyMobileNumber";
import { UnknowRoutes } from "../components/UnknowRoutes";
import Signin from "../container/Login/Signin";


const UnAuthenticationRoutes = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Signin />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/two-step-verification" element={<VerifyMobileNumber />} />

          <Route path="*" element={<UnknowRoutes />} />
        </Routes>
      </Router>
    </>
  );
};

export default UnAuthenticationRoutes;
